<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Novelty Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Novelty Line" file="novelty">
                번아웃과 고급스러운 나염, 특별한 후가공, 다양한 패턴의 자카드와 엠보싱 등. 한국의 숙련된 기술로 가공한 특별한 품목들을 만나실 수 있습니다.
            </sub-product>
        </sub-section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped>
</style>
